import { createApp } from 'vue'
import App from './App.vue'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faGitlab,
  faGithub,
  faLinkedin,
  faTelegram,
  faBootstrap,
  faPython,
  faVuejs,
  faJava,
  faAngular,
  faTrello,
  faJira,
  faBitbucket,
  faHtml5,
  faCss3,
  faReact
} from '@fortawesome/free-brands-svg-icons'
import {
  faLaptop,
  faSearch,
  faUsers,
  faDatabase,
  faLocationArrow
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faGitlab,
  faGithub,
  faLinkedin,
  faTelegram,
  faBootstrap,
  faPython,
  faVuejs,
  faJava,
  faAngular,
  faTrello,
  faJira,
  faBitbucket,
  faHtml5,
  faCss3,
  faReact,
  faLaptop,
  faSearch,
  faUsers,
  faDatabase,
  faLocationArrow
)

const app = createApp(App)
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(FloatingVue)
app.mount('#app')
